import { fetchRoute, GenericWrapperContext, SideMenuItem } from "cakemail-ui-components-v2"
import { useContext } from "react"
import { Stack } from "@mui/material"
import { useTranslation } from "react-i18next"
import "./styles.scss"
import { TOnboardingCompletedSetup } from "./types"
import { ERoutes } from "../../../../utils/url"
import { OnboardingContext } from "../../context"

export function OnboardingCompletedSetup({ }: TOnboardingCompletedSetup) {
    const onboardingContext = useContext(OnboardingContext)
    const { t } = useTranslation()

    const isAgency = onboardingContext?.isAgency

    return <Stack direction="column" className="onboardingCompletedSetup" gap={8} flex={1}>
        <SideMenuItem
            item={{
                text: isAgency ? t("nav-link-go-to-account") : t("nav-link-go-to-dashboard"),
                name: "onboarding-link-go-to-account"
            }}
            variant="soloItem"
            menuItemClick={() => {
                window.location.href = "#" + fetchRoute({ route: isAgency ? ERoutes.accounts : ERoutes.dashboard })
            }}
            selected={false}
        />
    </Stack>
}

export default OnboardingCompletedSetup